export const Countries = {
	AU: 'AU',
	NZ: 'NZ'
};

export const CountryNames = {
	[Countries.AU]: 'Australia',
	[Countries.NZ]: 'New Zealand'
};
